<script lang="ts">
    import { content, language } from "../../store"
    import { onClickFunction } from "../functions/additonalLinksClick"

    let footerUpper = []
    let footerLower = []
    $: {
        if (Object.values($content)?.length != 0) {
            //@ts-ignore
            footerUpper = Object.values($content.additional[1]).filter((e, i) => {
                //@ts-ignore
                e.nr = i //@ts-ignore
                return !e.service && !e.headerLink && e.language == $language
            }) //@ts-ignore
            footerLower = Object.values($content.additional[1]).filter((e, i) => {
                //@ts-ignore
                e.nr = i //@ts-ignore
                return e.service && !e.headerLink && e.language == $language
            })
        }
    }
</script>

<div class="footer">
    {#if Object.values($content).length != 0}
        <div class="add">
            {#each footerUpper as entry, i}
                <button
                    class="underlineable"
                    class:last="{i == footerUpper.length - 1}"
                    on:click="{(e) => {
                        onClickFunction(entry)
                        let el = e.currentTarget
                        el.classList.toggle('underlined')
                    }}">{entry.title}</button
                >
            {/each}
        </div>
        <div class="service">
            {#each footerLower as entry}
                <button
                    class="underlineable"
                    on:click="{(e) => {
                        onClickFunction(entry)
                        let el = e.currentTarget
                        el.classList.toggle('underlined')
                    }}">{entry.title}</button
                >
            {/each}
        </div>
    {/if}
</div>

<style lang="less">
    @import "../assets/css/variables.less";
    .footer {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        gap: 1px;
        height: 100%;
        .add {
            button {
                color: #748aaa;
                padding: 0px 10px;
                border-right: 1px solid #748aaa;
            }
            .last {
                border-right: 0px solid white;
            }
            background-color: @main-dark;
            min-height: 62px;
            color: #748aaa;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
        }
        .service {
            width: 100%;
            display: flex;
            justify-content: center;
            gap: 30px;
            padding: 20px 0px;
            background-color: @main-dark;
            min-height: 62px;
            flex-grow: 1;
            button {
                color: white;
                height: fit-content;
            }
        }
    }
</style>
